import React, { Component } from 'react';

const PendingPool = {};
const ReadyPool = {};

export default class ImageCell extends Component {
  state = {
    src: null,
  };

  UNSAFE_componentWillMount() {
    this.loadImage(this.props.src);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.setState({ src: null });
      this.loadImage(nextProps.src);
    }
  }

  onLoadImage = src => {
    ReadyPool[src] = true;

    if (src === this.props.src) {
      this.setState({ src });
    }
  };

  loadImage = source => {
    let src = source;

    if (ReadyPool[src]) {
      this.setState({ src });

      return;
    }

    if (PendingPool[src]) {
      PendingPool[src].push(this.onLoadImage);

      return;
    }
    PendingPool[src] = [this.onLoadImage];

    const img = new Image();
    img.onload = () => {
      PendingPool[src].forEach(callback => {
        callback(src);
      });
      delete PendingPool[src];
      img.onload = null;
      src = undefined;
    };
    img.src = src;
  };

  render() {
    const { src } = this.state;
    const style = src
      ? {
          backgroundImage: `url(${src})`,
          width: '70px',
          height: '70px',
          backgroundSize: 'cover',
        }
      : undefined;

    return <div className="exampleImage" style={style} />;
  }
}
